import * as React from 'react';
import SeatMapBase from '@websky/core/src/SeatMap/components/SeatMapService/Content/SeatMapServiceContent';
import { getServicesMinPrice } from './utils';
const SeatMapServiceContent = React.memo(props => {
    var _a, _b;
    const currentSegment = props.segments[props.segmentIndex];
    const isSSJ100 = ((_a = currentSegment.segmentInfo.aircraft) === null || _a === void 0 ? void 0 : _a.id) === '100115';
    const isTU214 = ((_b = currentSegment.segmentInfo.aircraft) === null || _b === void 0 ? void 0 : _b.id) === '100107';
    const splitByPrices = isSSJ100 || isTU214;
    const actualRowMinPrice = React.useRef(null);
    const actualNextRowMinPrice = React.useRef(null);
    const isNewServicePredicate = React.useCallback((row, nextRow) => {
        const [minPrice, nextMinPrice] = [getServicesMinPrice(row), getServicesMinPrice(nextRow)];
        if (minPrice !== null && minPrice !== actualRowMinPrice.current) {
            actualRowMinPrice.current = minPrice;
        }
        if (nextMinPrice !== null && nextMinPrice !== actualNextRowMinPrice.current) {
            actualNextRowMinPrice.current = nextMinPrice;
        }
        return actualRowMinPrice.current !== actualNextRowMinPrice.current;
    }, [actualRowMinPrice, actualNextRowMinPrice]);
    return React.createElement(SeatMapBase, Object.assign({}, props, { isNewServicePredicate: splitByPrices ? isNewServicePredicate : undefined }));
});
export default SeatMapServiceContent;
